import { AxiosError } from 'axios';
import store from '@/store';
import { Options, DialogType } from '@/components/mi-dialog/MiDialog';

export default class ErrorHandler {
  public static updated(message: string) {
    ErrorHandler.alert(message, 'Update Available', 'warning');
  }

  public static network(unknownError: unknown) {
    if (!unknownError) {
      return ErrorHandler.alert();
    }

    if (!(unknownError as AxiosError).isAxiosError) {
      return ErrorHandler.alert(unknownError as string);
    }

    const error: AxiosError = unknownError as AxiosError;

    const response = error.response;

    if (response) {
      switch (response.status) {
        case 422:
          const errors: string[] = [];

          Object.keys(response.data.errors).forEach((name: string) => {
            errors.push(response.data.errors[name]);
          });

          const message = errors.join('<br />');

          return ErrorHandler.alert(message, response.statusText);
      }

      return ErrorHandler.alert(response.status.toString(), response.statusText);
    }

    return ErrorHandler.alert();
  }

  public static alert(message: string = 'An unknown error occured', title: string = 'Error', type: DialogType = 'error') {
    const options: Options = {
      title,
      text: message,
      type,
      buttons: {
        confirm: {
          text: 'Ok',
        },
      },
    };

    store.dispatch('openDialog', options);
  }
}
